module.exports = __webpack_public_path__ + "img/vert-2.930e4349.png";